
import React from 'react';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { ShopFilterItem } from '../ShopFilterItem';
import { Shop } from '../../types';

export interface ShopsListProps {
  shops: Shop[];
  isSingleSelectionMode: boolean;
  singleSelectedShop: string;
  selectedShops: string[];
  isLoading?: boolean;
  onShopClick?: (shopId: string) => void;
  toggleShopSelection: (id: string) => void;
  setSingleSelectedShop?: (id: string) => void;
  onShopSettingsClick?: (shopId: string) => void;
  emptySearchTerm?: boolean;
}

export const ShopsList: React.FC<ShopsListProps> = ({
  shops,
  isSingleSelectionMode,
  singleSelectedShop,
  selectedShops,
  isLoading,
  onShopClick,
  toggleShopSelection,
  setSingleSelectedShop,
  onShopSettingsClick
}) => {
  if (isLoading) {
    return (
      <div className="py-4 text-center text-gray-500 dark:text-gray-400 text-sm">
        Chargement...
      </div>
    );
  }
  
  if (shops.length === 0) {
    return (
      <div className="py-4 text-center text-gray-500 dark:text-gray-400 text-sm">
        Aucune boutique disponible
      </div>
    );
  }

  const handleRadioChange = (value: string) => {
    console.log("Radio selection changed to:", value);
    if (setSingleSelectedShop) {
      setSingleSelectedShop(value);
    } else if (toggleShopSelection) {
      toggleShopSelection(value);
    }
  };

  if (isSingleSelectionMode) {
    return (
      <RadioGroup 
        value={singleSelectedShop} 
        onValueChange={handleRadioChange}
        className="space-y-2 w-full"
      >
        {shops.map((shop) => (
          <div key={shop.id} className="flex items-center py-2 w-full">
            <RadioGroupItem 
              value={shop.id} 
              id={`radio-${shop.id}`} 
              className="mr-3 h-4 w-4 text-custom-primary border-gray-300 dark:border-gray-600 dark:text-custom-secondaryLight"
            />
            <Label 
              htmlFor={`radio-${shop.id}`}
              className="flex items-center flex-1 cursor-pointer"
              onClick={() => onShopClick && onShopClick(shop.id)}
            >
              <ShopFilterItem 
                shop={shop} 
                displayFull 
                isSelected={singleSelectedShop === shop.id}
                onSettingsClick={onShopSettingsClick}
              />
            </Label>
          </div>
        ))}
      </RadioGroup>
    );
  }

  return (
    <ul className="space-y-2 w-full">
      {shops.map((shop) => (
        <li key={shop.id} className="flex items-center py-2 w-full">
          <Checkbox
            id={`checkbox-${shop.id}`}
            checked={selectedShops.includes(shop.id)}
            onCheckedChange={() => toggleShopSelection && toggleShopSelection(shop.id)}
            className="mr-3 h-4 w-4 text-custom-primary border-gray-300 dark:border-gray-600 dark:text-custom-secondaryLight"
          />
          <Label 
            htmlFor={`checkbox-${shop.id}`}
            className="flex items-center flex-1 cursor-pointer"
            onClick={() => onShopClick && onShopClick(shop.id)}
          >
            <ShopFilterItem 
              shop={shop} 
              displayFull 
              isSelected={selectedShops.includes(shop.id)}
              onSettingsClick={onShopSettingsClick}
            />
          </Label>
        </li>
      ))}
    </ul>
  );
};
